import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ShopPage from "../pages/shop/page";
import CheckoutPage from "../pages/checkout/page";
import ContactPage from "../pages/contact/page";
import ManagePage from "../pages/manage/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shop",
    element: <ShopPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/manage",
    element: <ManagePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
